import React from 'react';
import { Button, Modal, Form, Icon, List } from 'semantic-ui-react'
import { connect } from 'react-redux';

import { getV2TrainingModules } from '../../../actions/v2_training_modules'
import { getTrainees } from '../../../actions/trainees'
import { getCategorizedTags } from '../../../actions/tags'
import AppComponent from '../app_component'

class TrainingMatrixModal extends AppComponent {
  constructor(props){
    super(props);

    var tag = {...props.tag}

    this.state = {
      tag_name: props.mode==='create' ? '' : tag.tag_name,
      old_tag_name: props.mode==='create' ? '' : tag.tag_name,
      v2TrainingModules: [],
      stepIndex: 0,
      loadingTrainingModules: false,
      loadingTrainees: false,
      modules_ids: props.mode==='create' ? [] : tag.modules_ids,
      trainees_ids: props.mode==='create' ? [] : tag.trainees_ids,
      trainees: [],
      search_term: '',
      context: props.context,
      mode: props.mode,
      contextDictionary: {
        regions: {
          title: 'Create Region Matrix',
          name_step_instruction: 'Enter the name of the region matrix.',
          name_label: 'Matrix Name',
          name_placeholder: 'Matrix name',
          trainees_step_instruction: 'Select trainees to include to this region matrix.',
          category_step_instruction: 'Select training modules (category) which applies to your region.',
          duplicate_error_message: 'ERROR: A region or custom tag named \'tag_name\' already exists.'
        },
        tags: {
          title: props.mode==='create' ? 'Create Team Tag' : 'Update Team Tag' ,
          name_step_instruction: props.mode==='create' ? 'Enter the name of the team tag.' : 'Update the name of the team tag.',
          name_label: 'Team Name',
          name_placeholder: 'Team name',
          trainees_step_instruction: 'Select the trainees that you want to apply the tag to.',
          category_step_instruction: 'Select the training modules (category) that you want to apply the tag to.',
          duplicate_error_message: 'ERROR: A region or team tag named \'tag_name\' already exists.'
        }
      },
      parent_name: props.parentName
    }
  }

  componentDidMount() {
    this.props.getCategorizedTags()
  }

  componentWillReceiveProps(nextProps){
    this.handleTagsNextProps(nextProps)
    this.handleV2TrainingModulesNextProps(nextProps)
    this.handleTraineesNextProps(nextProps)
  }

  handleTagsNextProps = (nextProps) => {
    const { regions, tags, requestType } = nextProps.tags
    if (this.props.tags.requestType === requestType) return;
    if (requestType === 'GET_CATEGORIZED_TAGS_SUCCESS') {
      this.setState({ tags, regions })
    }
  }

  handleV2TrainingModulesNextProps=(nextProps)=>{
    const { v2TrainingModules, requestType} = nextProps.v2TrainingModules
    if (this.props.v2TrainingModules.requestType === requestType) return;
    if (requestType==='GET_V2_TRAINING_MODULES_REQUEST'){
      this.setState({loadingTrainingModules: true})
    } else {
      this.setState({v2TrainingModules, loadingTrainingModules: false})
    }
  }

  handleTraineesNextProps=(nextProps)=>{
    const { trainees, requestType} = nextProps.trainees
    if (this.props.trainees.requestType === requestType) return;
    if (requestType==='GET_TRAINEES_REQUEST'){
      this.setState({loadingTrainees: true})
    } else {
      this.setState({trainees, loadingTrainees: false})
    }
  }

  renderNameStep = () => {
    const { tag_name, contextDictionary, context, duplicateError } = this.state
    return (
      <div>
        <h4 className='step-header'><span>Step {this.state.stepIndex+1})</span> <span>{contextDictionary[context].name_step_instruction}</span></h4>
        <Form.Input name='matrix_name' className='create-matrix-name' fluid label={contextDictionary[context].name_label} placeholder={contextDictionary[context].name_placeholder} defaultValue={tag_name} onChange={ (target, prop) => this.onTagNameChange(prop) } />
        { duplicateError && <div className="duplicate-module-error">{contextDictionary[context].duplicate_error_message.replace("tag_name", tag_name)}</div>}
      </div>
    )
  }

  renderSearchInput = (placeholder, defaultValue, onSearch, onClearSearch, name='search_term') => {
    return (
      <div className="field">
        <div className="ui fluid icon input custom-search-input">
          <input name={name} placeholder={placeholder} type="text" value={defaultValue} onChange={onSearch}/>
          { defaultValue.length === 0 && <i aria-hidden="true" className="search icon"></i> }
          { defaultValue.length > 0 && <i aria-hidden="true" className="close icon" onClick={onClearSearch}></i> }
        </div>
      </div>
    )
  }

  onSearch = (evt) => {
    if(evt.target.name!=='search_term') return
    this.setState({
      search_term: evt.target.value,
    })
  }

  onClearSearch = (evt) => {
    this.setState({
      search_term: '',
    })
  }

  getFilteredTrainingModules = (category) => {
    var { v2TrainingModules, search_term } = this.state
    var default_frequency, label
    return v2TrainingModules.filter(training_module => {
      if (search_term.length > 0){
        default_frequency = (training_module.default_frequency && training_module.default_frequency!==0) ? `${training_module.default_frequency} years` : `As required`
        label = `${training_module.name} ${default_frequency}`
        return label.includes(search_term) && training_module.category === category
      }
      else {
        return training_module.category === category
      }
    })
  }

  renderCategory = (category) => {
    var {search_term, stepIndex, loadingTrainingModules, contextDictionary, context} = this.state
    var v2TrainingModules = this.getFilteredTrainingModules(category)
    if (loadingTrainingModules) {
      return ( <p className='loading-training-modules'>Loading training modules <Icon name="circle notch" loading/></p>)
    }
    else {
      return (
        <div>
          <h4 className='step-header'><span>Step {stepIndex + 1})</span> <span>{contextDictionary[context].category_step_instruction.replace('category', this.modulesGroupLabels()[category])}</span></h4>
          { this.renderSearchInput("Search training module...", search_term, this.onSearch, this.onClearSearch)  }
          {
            this.renderTrainingModules(v2TrainingModules)
          }
          {
            v2TrainingModules.length === 0 &&
            <div className="field">
              No result for '{this.state.search_term}'.
            </div>
          }
        </div>
      )
    }
  }

  renderTrainingModules(training_modules){
    var trainingModuleItems = []
    var training_module
    for (var index in training_modules) {
      training_module = training_modules[index]

      var default_frequency = (training_module.default_frequency && training_module.default_frequency!==0) ? `${training_module.default_frequency} years` : `As required`
      trainingModuleItems.push(
        <List.Item key={ index }>
          <Form.Checkbox
            key={ training_module.id }
            label={ `${training_module.name} (${default_frequency})` }
            onChange={ (target, props) => this.onModuleTick(props) }
            id={ "training_module_" + training_module.id }
            value={training_module.id}
            inline
            checked={this.state.modules_ids.includes(training_module.id)}
          />
        </List.Item>
      )
    }

    return trainingModuleItems
  }

  renderTraineesStep = () => {
    var {search_term, stepIndex, loadingTrainees, contextDictionary, context} = this.state
    if (loadingTrainees) {
      return ( <p className='loading-training-modules'>Loading trainees <Icon name="circle notch" loading/></p>)
    }
    return (
      <div>
        <h4 className='step-header'>Step {stepIndex+1}) {contextDictionary[context].trainees_step_instruction}</h4>
        { this.renderSearchInput("Search trainee...", search_term, this.onSearch, this.onClearSearch)  }
        { this.renderTrainees() }
      </div>
    )
  }

  getFilteredTrainees = () => {
    var { trainees, search_term } = this.state
    var trainee_details
    return trainees.filter(trainee => {
      if (search_term.length > 0){
        trainee_details = trainee.email && trainee.email.length > 0 ? `${trainee.fullname} (${trainee.email})` : trainee.fullname
        return trainee_details.includes(search_term)
      }
      else return true
    })
  }

  renderTrainees = () => {
    var trainees = this.getFilteredTrainees()
    var traineeItems = []
    var trainee, trainee_details
    for (var index in trainees) {
      trainee = trainees[index]
      trainee_details = trainee.email && trainee.email.length > 0 ? `${trainee.fullname} (${trainee.email})` : trainee.fullname
      traineeItems.push(
        <List.Item key={ index }>
          <Form.Checkbox
            key={ trainee.id }
            label={ trainee_details }
            onChange={ (target, props) => this.onTraineeTick(props) }
            id={ "trainee_" + trainee.id }
            value={trainee.id}
            inline
            checked={this.state.trainees_ids.includes(trainee.id)}
          />
        </List.Item>
      )
    }
    return traineeItems
  }

  renderTrainingRegisterSteps = () => {
    switch (this.state.stepIndex) {
      case 0: return this.renderNameStep();
      case 1: return this.renderCategory('all');
      case 2: return this.renderCategory('other');
      case 3: return this.renderTraineesStep();
      default: return;
    }
  }

  renderTraineesSteps = () => {
    switch (this.state.stepIndex) {
      case 0: return this.renderNameStep();
      case 1: return this.renderTraineesStep();
      default: return;
    }
  }

  renderV2TrainingModulesSteps = () => {
    switch (this.state.stepIndex) {
      case 0: return this.renderNameStep();
      case 1: return this.renderCategory('all');
      case 2: return this.renderCategory('other');
      default: return;
    }
  }

  setStepIndex = (value) => {
    var { parent_name } = this.state
    if (['TrainingRegister', 'V2TrainingModules'].includes(parent_name)) {
      if (value===1) {
        this.props.getV2TrainingModules()
      }
      if (value===3) {
        this.props.getTrainees()
      }
    }
    else if (parent_name === 'Trainees') {
      if (value===1) {
        this.props.getTrainees()
      }
    }

    this.setState({
      stepIndex: value,
      search_term: ''
    })
  }

  onTagNameChange(prop) {
    let { duplicateError, mode } = this.state
    if (mode==='create'){
      duplicateError = (this.isExistingRegion(prop.value) || this.isExistingCustomTag(prop.value))
    } else {
      duplicateError = ((this.isExistingRegion(prop.value) || this.isExistingCustomTag(prop.value)) && prop.value !== this.props.tag.tag_name)
    }
    this.setState({
      tag_name: prop.value,
      duplicateError
    })
  }

  isExistingRegion = (value) => {
    return this.state.regions.find(region => {return region.value === value })
  }

  isExistingCustomTag = (value) => {
    return this.state.tags.find(tag => {return tag.value === value })
  }

  onModuleTick(prop) {
    var modules_ids = this.state.modules_ids

    if(prop.checked) {
      //add triggered module into the list
      modules_ids.push(prop.value)
    }
    else {
      //remove triggered module from the list
      modules_ids = modules_ids.filter(module => module !== prop.value)
    }
    this.setState({ modules_ids })
  }

  onTraineeTick(prop) {
    var trainees_ids = this.state.trainees_ids

    if(prop.checked) {
      //add triggered trainee into the list
      trainees_ids.push(prop.value)
    }
    else {
      //remove triggered trainee from the list
      trainees_ids = trainees_ids.filter(trainee => trainee !== prop.value)
    }
    this.setState({ trainees_ids })
  }

  onCreate() {
    const { tag_name, modules_ids, trainees_ids, context, parent_name } = this.state

    var details = {
      tag_name: tag_name,
      modules_ids: modules_ids,
      trainees_ids: trainees_ids,
      context: context,
      parent_name: parent_name
    }
    this.props.onCreate(details)
  }

  onUpdate() {
    const { tag_name, old_tag_name, modules_ids, trainees_ids, context, parent_name } = this.state

    var details = {
      tag_name: tag_name,
      old_tag_name: old_tag_name,
      modules_ids: modules_ids,
      trainees_ids: trainees_ids,
      context: context,
      parent_name: parent_name
    }
    this.props.onUpdate(details)
  }

  render() {
    const {stepIndex, trainees_ids, tag_name, context, contextDictionary, mode, parent_name, modules_ids, duplicateError} = this.state
    return (
      <Modal size={ 'tiny' } dimmer={ 'inverted' } open={ true }>
        <Modal.Header>{contextDictionary[context].title}</Modal.Header>
        <Modal.Content scrolling className='create-matrix-content'>
          <Form>
            { parent_name==='TrainingRegister' && this.renderTrainingRegisterSteps() }
            { parent_name==='Trainees' && this.renderTraineesSteps() }
            { parent_name==='V2TrainingModules' && this.renderV2TrainingModulesSteps() }
          </Form>
        </Modal.Content>
        {
          parent_name==='TrainingRegister' &&
          <Modal.Actions>
            { 0 < stepIndex && <Button primary content="Previous Step" onClick={ () => this.setStepIndex(stepIndex - 1) }/> }
            { stepIndex < 3 && <Button disabled={tag_name.length===0 || duplicateError} primary content="Next Step" onClick={ () => this.setStepIndex(stepIndex + 1) }/> }
            { stepIndex === 3 && <Button disabled={trainees_ids.length===0} positive content="Create" onClick={ () => this.onCreate() }/> }
            { <Button negative content="Cancel" onClick={ () => this.props.onClose() }/> }
          </Modal.Actions>
        }
        {
          parent_name==='Trainees' && mode === 'create' &&
          <Modal.Actions>
            { 0 < stepIndex && <Button primary content="Previous Step" onClick={ () => this.setStepIndex(stepIndex - 1) }/> }
            { stepIndex === 0 && <Button disabled={tag_name.length===0 || duplicateError} primary content="Next Step" onClick={ () => this.setStepIndex(stepIndex + 1) }/> }
            { stepIndex === 1 && <Button disabled={trainees_ids.length===0} positive content="Create" onClick={ () => this.onCreate() }/> }
            { <Button negative content="Cancel" onClick={ () => this.props.onClose() }/> }
          </Modal.Actions>
        }
        {
          parent_name==='Trainees' && mode === 'update' &&
          <Modal.Actions>
            { 0 < stepIndex && <Button primary content="Previous Step" onClick={ () => this.setStepIndex(stepIndex - 1) }/> }
            { stepIndex === 0 && <Button disabled={tag_name.length===0 || duplicateError} primary content="Next Step" onClick={ () => this.setStepIndex(stepIndex + 1) }/> }
            { stepIndex === 1 && <Button disabled={trainees_ids.length===0} positive content="Update" onClick={ () => this.onUpdate() }/> }
            { <Button negative content="Cancel" onClick={ () => this.props.onClose() }/> }
          </Modal.Actions>
        }
        {
          parent_name==='V2TrainingModules' && mode === 'create' &&
          <Modal.Actions>
            { 0 < stepIndex && <Button primary content="Previous Step" onClick={ () => this.setStepIndex(stepIndex - 1) }/> }
            { stepIndex < 2 && <Button disabled={tag_name.length===0 || duplicateError} primary content="Next Step" onClick={ () => this.setStepIndex(stepIndex + 1) }/> }
            { stepIndex === 2 && <Button disabled={modules_ids.length===0} positive content="Create" onClick={ () => this.onCreate() }/> }
            { <Button negative content="Cancel" onClick={ () => this.props.onClose() }/> }
          </Modal.Actions>
        }
        {
          parent_name==='V2TrainingModules' && mode === 'update' &&
          <Modal.Actions>
            { 0 < stepIndex && <Button primary content="Previous Step" onClick={ () => this.setStepIndex(stepIndex - 1) }/> }
            { stepIndex < 2 && <Button disabled={tag_name.length===0 || duplicateError} primary content="Next Step" onClick={ () => this.setStepIndex(stepIndex + 1) }/> }
            { stepIndex === 2 && <Button disabled={modules_ids.length===0} positive content="Update" onClick={ () => this.onUpdate() }/> }
            { <Button negative content="Cancel" onClick={ () => this.props.onClose() }/> }
          </Modal.Actions>
        }
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    v2TrainingModules: state.v2TrainingModules,
    trainees: state.trainees,
    tags: state.tags
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getV2TrainingModules: (options) => {
      return dispatch(getV2TrainingModules(options))
    },
    getTrainees: (options) => {
      return dispatch(getTrainees(options))
    },
    getCategorizedTags: () => {
      return dispatch(getCategorizedTags())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingMatrixModal);




// WEBPACK FOOTER //
// ./src/views/components/modals/training_matrix_modal.js